import type GetRoomAvailabilityRequest from '../schema/GetRoomAvailabilityRequest';
import type GetRoomAvailabilityResponse from '../schema/GetRoomAvailabilityResponse';
import { getRoomAvailabilityConstants } from '../constants';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { makePostRequest } from 'owa-ows-gateway';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Makes the GetRoomAvailability request
 * @param request The request object
 * @param scenarioNameForHeader The name for the scenario which will be sent in the header
 */
export default async function getRoomAvailabilityService(
    request: GetRoomAvailabilityRequest,
    scenarioNameForHeader: string
): Promise<GetRoomAvailabilityResponse> {
    const headers = {};
    headers[getRoomAvailabilityConstants.APPNAME_HEADERNAME] =
        getRoomAvailabilityConstants.APPNAME_HEADERVALUE;
    headers[getRoomAvailabilityConstants.SCENARIONAME_HEADERNAME] = scenarioNameForHeader;

    const response = await makePostRequest(
        isFeatureEnabled('cal-mf-placesb2')
            ? getRoomAvailabilityConstants.ENDPOINT_URLB2
            : getRoomAvailabilityConstants.ENDPOINT_URL,
        request,
        undefined /* correlationId */,
        true /* returnFullResponse */,
        headers /* customHeaders: */,
        undefined,
        undefined,
        undefined,
        'getRoomAvailability' /* actionName */
    );

    if (response && isSuccessStatusCode(response.status)) {
        return response.json();
    } else {
        return Promise.resolve(null);
    }
}
